import * as React from 'react';

import styled from '../../theme';
import { AboutRenderer, IRenderProps } from '../../models/About';

const Header = styled.div`
  text-align: center;
`;

const PressContainer = styled.div`
  margin-top: 30px;
`;

const PressItemContainer = styled.div`
  display: flex;
  line-height: 1.5;

  > *:first-child {
    margin-right: 25px;
    width: 50px;
    text-align: right;
  }

  > *:nth-child(2) {
    width: 100%;
  }
`;

class Press extends React.PureComponent<IRenderProps> {
  render() {
    return (
      <div>
        <Header>Press</Header>
        <PressContainer>
          {this.props.data.fields.pressLinks.map((pressLink) => (
            <PressItemContainer key={pressLink.fields.articleName}>
              <div>{pressLink.fields.year}</div>
              <a
                rel="nofollow noreferrer noopener"
                target="_blank"
                href={pressLink.fields.articleUrl}
              >
                {pressLink.fields.articleName}
              </a>
            </PressItemContainer>
          ))}
        </PressContainer>
      </div>
    );
  }
}

export default function Wrapper() {
  return <AboutRenderer render={Press} />;
}



// WEBPACK FOOTER //
// ./src/scenes/About/Press.tsx